export default __webpack_public_path__ + "static/media/soundcloud.fc1041ca.svg";